var map = {
	"./black/peck.gif": 1664,
	"./black/static.gif": 9677,
	"./black/walk.gif": 5324,
	"./white/peck.gif": 6386,
	"./white/static.gif": 3887,
	"./white/walk.gif": 7374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3141;